// Builds the /customer/checkout deep-link used by the /filing plan picker.
// Carries the looked-up company through to checkout so company fields are
// pre-populated and cs_annual deadline-anchored billing has the company
// number. Pure function — unit-tested in filingCheckout.test.js.

// The three picker tiles, in the order they render on /filing.
export const FILING_PLAN_SLUGS = {
  bundle: 'cs_filing_bundle',   // Tile 1 — Verify + File £119
  oneOff: 'cs_filing',          // Tile 2 — One-off Filing £100
  annual: 'cs_annual',          // CS01 annual standalone £89/yr (now under "More options")
  doEverything: 'verify_cs_psc' // Verify + CS + the buyer's own PSC statement £140
};

// SKUs introduced with the VS01 PSC verification product line.
export const VS01_PLAN_SLUGS = {
  bundleAnnual: 'cs_vs_bundle_annual', // /filing Tile 3 — CS01 + VS01 £138/yr
  vs01OneOff: 'vs01_oneoff',           // /psc-verification/file — VS01 one-off £60
  vs01Annual: 'vs01_annual'            // /psc-verification/file — VS01 annual £49/yr
};

export function buildFilingCheckoutUrl(plan, company = {}) {
  const params = new URLSearchParams({ plan });
  if (company.companyNumber) params.set('companyNumber', company.companyNumber);
  if (company.companyName) params.set('companyName', company.companyName);
  // Person details the diagnostic already MATCHED against the Companies House
  // register — carried so checkout can show them as "confirmed from CH" (and
  // pre-fill) rather than re-asking. `chc=1` is only set when the register
  // actually matched, so checkout never labels typed data as confirmed.
  if (company.chConfirmed) {
    params.set('chc', '1');
    if (company.firstName) params.set('firstName', company.firstName);
    if (company.lastName) params.set('lastName', company.lastName);
    if (company.role) params.set('role', company.role);
  }
  return `/customer/checkout?${params.toString()}`;
}
